import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 环境列表
export const setEnvs: Mutation<IModuleState> = (state, payload) => {
  state.envs.data = payload.data;
  state.envs.loading = !!payload.loading;
};
